export const NOTIFICATION_TEXT = {
    HEADER: "Notifications",
    NO_NOTIFICATIONS: "No notifications",
    MARK_ALL_AS_READ: "Mark all as read",
    FETCH_ERROR: "Failed to fetch notifications.",
    MARK_READ_ERROR: "Failed to mark notifications as read.",
    UNREAD_NOTIFICATION:"Unread Notification",
    FAILED_TO_MARK_READ:"Failed to mark as read"
};

export const MESSAGES_TYPE = {
    INFO: "INFO",
    SUCCESS: "SUCCESS",
    WARNING: "WARNING",
    ERROR: "ERROR",
}

export const NOTIFICATIONS_TYPE = {
    ATTENDANCE: "attendance",
    BILL: "bill",
    TASK: "task"
}

export const MARK_AS_READ="Mark As Read"

export const NOTIFICATION_COLORS = {
  INFO: "bg-blue-50 border border-blue-200 text-blue-800",
  WARNING: "bg-yellow-50 border border-yellow-200 text-yellow-800",
  SUCCESS: "bg-green-50 border border-green-200 text-green-800",
  ERROR: "bg-red-50 border border-red-200 text-red-800",
  DEFAULT: "bg-gray-50 border border-gray-200 text-gray-800",
};